<template>
	<v-app-bar app fixed dense color="white" flat>
		<v-app-bar-nav-icon @click.stop="toggleNav"></v-app-bar-nav-icon>
		<v-spacer></v-spacer>

		<!-- My notifications -->
		<v-menu offset-y left>
			<template v-slot:activator="{ on }">
				<app-button flat v-on="on" no-margin>
					<app-icon :icon="unread ? 'fa-bell' : 'far fa-bell'" />
					<v-avatar
						v-if="unread"
						size="18"
						style="margin-top: -16px; margin-left: -6px; font-size:12px;"
					>{{unread >= 10 ? '9+' : unread}}</v-avatar>
				</app-button>
			</template>

			<v-list dense class="pa-0" right>
				<v-list-item v-if="notifications.length">
					<v-spacer />
					<v-list-item-action>
						<a @click="onMarkAll" style="font-size: 12px;">Mark all as read</a>
					</v-list-item-action>
				</v-list-item>
				<v-list-item-content v-else class="pa-2">
					<v-list-item-title>No notifications</v-list-item-title>
				</v-list-item-content>
				<template
					v-for="(notification, i) in notifications"
				>
					<v-list-item
						:key="`notification-${notification._id}`"
						:class="!notification.read ? 'blue lighten-5' : ''"
						:to="{ name: 'my-notification', params: { notification: notification._id } }"
					>
						<v-list-item-content>
							<v-list-item-title>
								<span>{{notification.title}}</span>
								<span
									class="ml-1 grey--text font-italic"
								>{{notification._id | datetime(true) }}</span>
							</v-list-item-title>
							<v-list-item-subtitle>{{notification.subject}}</v-list-item-subtitle>
							<app-icon
								:icon="notification.read ? 'far fa-circle' : 'fa-circle'"
								size="8"
								style="position:absolute; right: 20px;"
							/>
						</v-list-item-content>
					</v-list-item>
					<v-divider
						:key="`notification-divider-${notification._id}`"
						v-if="i !== notifications.length - 1"
					/>
				</template>
				<v-list-item v-if="notifications.length">
					<v-list-item-action>
						<router-link
							:to="{ name: 'my-notifications' }"
							style="font-size: 12px; text-decoration: none;"
						>View All</router-link>
					</v-list-item-action>
				</v-list-item>
			</v-list>
		</v-menu>

		<!-- My information -->
		<v-menu offset-y>
			<template v-slot:activator="{ on }">
				<app-button flat v-on="on" no-margin>
					<span class="mr-2 d-none d-sm-flex" v-if="$ravello.me">
						{{$ravello.me.firstName || $ravello.me.username}}
					</span>
					<span><app-icon icon="fa-ellipsis-v" /></span>
				</app-button>
			</template>

			<v-list>
				<v-list-item @click="logout">
					<v-list-item-title>Logout</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
export default {
	data() {
		return {
			notifications: [],
			socket: null,
			unread: 0,
		}
	},
	async mounted() {
		this.unread = await this.fetchNotifications(false, true)
		this.notifications = await this.fetchNotifications()

		this.socket = this.$ravello.socket('notifications')
		this.socket.on('new', (id) => {
			this.onNewNotification(id)
		})
		this.socket.on('read', (id) => {
			if (this.unread > 0) {
				this.unread -= 1
			}

			const found = this.notifications.find(notification => notification._id === id)
			if (found) {
				found.read = true
			}
		})
		this.socket.on('readAll', () => {
			this.unread = 0
			this.notifications.forEach((notification) => {
				notification.read = true
			})
		})
	},
	methods: {
		toggleNav() {
			this.$store.dispatch('app/toggleNav')
		},
		logout() {
			this.$ravello.ssoLogout()
		},
		async onNewNotification(id) {
			try {
				const notification = await this.$ravello.request().me()
					.to('notifications')
					.to(id)
					.get()

				this.notifications.unshift(notification)
				this.unread += 1
				if (this.notifications.length > 5) {
					this.notifications.pop()
				}
			// eslint-disable-next-line no-empty
			} catch (err) {}
		},
		async fetchNotifications(read = null, count = false) {
			const query = this.$ravello.request().me()
				.to('notifications')
				.limit(count ? 50 : 5)
				.sort('-_id')

			if (read !== null) {
				query.param('read', read)
			}

			if (count) {
				const res = await query.field('users').get()
				return res ? res.length : 0
			}

			return query.get()
		},
		async onMarkAll() {
			if (this.unread > 0) {
				this.unread = 0
			}

			await this.$ravello.request().me()
				.to('notifications')
				.to('read')
				.create()

			this.socket.emit('readAll')
		},
	},

	beforeDestroy() {
		if (this.socket) {
			this.socket.disconnect()
		}
	},
}
</script>

<style scoped>
	.v-btn::before {
		background: inherit;
	}
	.v-btn:hover {
		color: var(--v-primary-base);
	}
</style>
